const INSTANT_DELIVERY_TYPES = new Set(["akun", "voucher"]);

/**
 * The backend computes `instant_delivery` from the product's available code
 * pool. Do not infer it from `instant_delivery_data`: legacy records can keep
 * empty field keys and the public client cannot safely validate secret codes.
 */
export const hasInstantDelivery = (product) => {
  if (product?.instant_delivery !== true) return false;

  // Produk milik admin yang dipenuhi lewat API supplier (undeadshopp.com)
  // selalu instan apa pun tipenya: stoknya ada di sisi supplier dan kodenya
  // dikirim otomatis begitu pembayaran lunas.
  const mode = String(product?.fulfillment_mode || "").trim().toLowerCase();
  if (mode === "api") return true;

  const productType = String(product?.type || "").trim().toLowerCase();
  return INSTANT_DELIVERY_TYPES.has(productType);
};


